import { render } from "./ItemsLocations.vue?vue&type=template&id=0e4e00a4&scoped=true&ts=true"
import script from "./ItemsLocations.vue?vue&type=script&lang=ts"
export * from "./ItemsLocations.vue?vue&type=script&lang=ts"

import "./ItemsLocations.vue?vue&type=style&index=0&id=0e4e00a4&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4e00a4"]])

export default __exports__